import React from "react";
import { Route } from "react-router-dom";


import LandingArtist from "../pages/artist/pages/landingArtist";
import ViewProfileArtist from "../pages/artist/pages/viewProfileArtist";
import ViewProfileReSeller from "../pages/artist/pages/viewProfileReSeller";
import EditProfileReSeller from "../pages/artist/pages/editProfileReSeller";
import MyWishlistArtist from "../pages/artist/pages/myWishlistArtist";
import MyWishlistReSeller from "../pages/artist/pages/myWishlistReSeller";
import MyCartArtist from "../pages/artist/pages/myCartArtist";
import MyCartReSeller from "../pages/artist/pages/myCartReSeller";
import MyOrderArtist from "../pages/artist/pages/myOrdersArtist";
import MyOrderReSeller from "../pages/artist/pages/myOrdersReSeller";
import EditProfileArtist from "../pages/artist/pages/editProfileArtist";
import UploadArtworkArtist from "../pages/artist/pages/uploadArtworkArtist";
import UploadArtworkReSeller from "../pages/artist/pages/uploadArtworkReSeller";
import LandingReSeller from "../pages/artist/pages/landingReSeller";
import ArtworkArtistAll from "../pages/artist/pages/artworkArtistAll";
import ArtworkReSellerAll from "../pages/artist/pages/artworkReSellerAll";
import ViewArtistArtworkDetails from "../pages/artist/pages/viewArtistArtworkDetails";
import ViewReSellerArtworkDetails from "../pages/artist/pages/viewReSellerArtworkDetails";
import AddArtworkDetailsArtist from "../pages/artist/pages/addArtworkArtist";
import ReSellerArtistList from "../pages/artist/pages/reSellerArtistList";
import AddArtworkDetailsReSeller from "../pages/artist/pages/addArtworkReSeller";
import ViewProfileUser from "../pages/artist/pages/viewProfileUser";


// Add other admin-specific imports...

const ArtistRoutes = () => {
  return (
    <>
        <Route path="/viewProfileUser" element={<ViewProfileUser />} />
        
        <Route path="/landingArtist" element={<LandingArtist />} />
        <Route path="/viewProfileArtist" element={<ViewProfileArtist />} />
        <Route path="/viewProfileReSeller" element={<ViewProfileReSeller />} />
        <Route path="/editProfileReSeller" element={<EditProfileReSeller />} />
        <Route path="/myWishlistArtist" element={<MyWishlistArtist />} />
        <Route path="/myWishlistReSeller" element={<MyWishlistReSeller />} />
        <Route path="/myCartArtist" element={<MyCartArtist />} />
        <Route path="/myCartReSeller" element={<MyCartReSeller />} />
        <Route path="/myOrdersArtist" element={<MyOrderArtist />} />
        <Route path="/myOrdersReSeller" element={<MyOrderReSeller />} />
        <Route path="/editProfileArtist/:tabParam" element={<EditProfileArtist />} />
        <Route path="/uploadArtworkArtist/:id" element={<UploadArtworkArtist />} />
        <Route path="/uploadArtworkReSeller/:id" element={<UploadArtworkReSeller />} />
        <Route path="/landingReSeller" element={<LandingReSeller />} />
        <Route path="/artworkArtistAll" element={<ArtworkArtistAll />} />
        <Route path="/artworkReSellerAll" element={<ArtworkReSellerAll />} />
        <Route path="/viewArtistArtworkDetails/:id" element={<ViewArtistArtworkDetails />} />
        <Route path="/viewReSellerArtworkDetails/:id" element={<ViewReSellerArtworkDetails />} />
        <Route path="/addArtworkArtist" element={<AddArtworkDetailsArtist />} />
        <Route path="/addArtworkArtist/:id" element={<AddArtworkDetailsArtist />} />
        <Route path="/reSellerArtistList" element={<ReSellerArtistList />} />
        <Route path="/addArtworkReSeller" element={<AddArtworkDetailsReSeller />} />          
        <Route path="/addArtworkReSeller/:id/:from" element={<AddArtworkDetailsReSeller />} />

        {/* Add other admin routes here */}
    </>
  );
};

export default ArtistRoutes;
